"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const main_stepper_1 = require("../../../layouts/main-stepper");
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const project_initiation_1 = require("./mainSteps/project-initiation");
const react_redux_1 = require("react-redux");
const themes_1 = require("../../../utils/themes");
const pre_processing_1 = require("./mainSteps/pre-processing");
const data_transformation_1 = require("./mainSteps/data-transformation");
const model_tuning_1 = require("./mainSteps/model-tuning");
const model_saving_1 = require("./mainSteps/model-saving");
const react_router_dom_1 = require("react-router-dom");
const actions_1 = require("../../actions/actions");
require("bootstrap/dist/css/bootstrap.min.css");
const style_1 = tslib_1.__importDefault(require("../../../utils/style"));
const stepNames = {
    1: "project-init",
    2: "pre-processing",
    3: "data-transformation",
    4: "model-tuning",
    5: "model-saving",
};
const MagmaDashboard = (props) => {
    const dispatch = react_redux_1.useDispatch();
    const mainStep = react_redux_1.useSelector((state) => state.mainStep.no);
    const [step, setStep] = react_1.useState(mainStep);
    const history = react_router_dom_1.useHistory();
    const { step: currentStep } = react_router_dom_1.useParams();
    const styleLocal = style_1.default();
    react_1.useEffect(() => {
        if (step !== mainStep) {
            setStep(mainStep);
        }
        const stepName = stepNames[mainStep];
        if (stepName && currentStep !== stepName) {
            history.replace(`/${stepName}`);
        }
    }, [mainStep, currentStep, history]);
    const handleChangeMainStep = (step) => {
        if (mainStep > step) {
            dispatch(actions_1.changeMainStep(step));
        }
        else {
            console.log("cant access your future!!!");
        }
    };
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: themes_1.theme },
        react_1.default.createElement(core_1.Grid, { container: true, className: styleLocal.customGridBackground },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 1, sm: 1, md: 1, lg: 1 }),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 10, sm: 10, md: 10, lg: 10, style: { textAlign: "center" } },
                react_1.default.createElement(main_stepper_1.MainStepper, { step: step, changeMainStep: handleChangeMainStep })),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 1, sm: 1, md: 1, lg: 1 }),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 12 },
                step === 1 && react_1.default.createElement(project_initiation_1.ProjectInitiation, null),
                step === 2 && react_1.default.createElement(pre_processing_1.PreProcessing, null),
                step === 3 && react_1.default.createElement(data_transformation_1.DataTransformation, null),
                step === 4 && react_1.default.createElement(model_tuning_1.ModelTuning, null),
                step === 5 && react_1.default.createElement(model_saving_1.ModelSaving, null)))));
};
exports.default = MagmaDashboard;
//# sourceMappingURL=magma-dashboard.js.map